import script from "./PopupEditer.vue?vue&type=script&setup=true&lang=js"
export * from "./PopupEditer.vue?vue&type=script&setup=true&lang=js"

import "./PopupEditer.vue?vue&type=style&index=0&id=108d8660&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-108d8660"]])

export default __exports__